import { useNavigate } from 'react-router-dom'
import { useRestaurant } from '@local/do-secundo-restaurant-provider'
import { useCallback } from 'react'

// Updates the base path when redirecting from a fastLink to home ('/')
// to prevent useRedirectToFulfillment from redirecting back to the fastLink path
// when it adds the fulfillment mode to the restaurant path
export const useRedirectHome = () => {
  const navigate = useNavigate()

  const { updateApplicableConfigsRequest, setBasePath } = useRestaurant()

  const redirectHome = useCallback(() => {
    setBasePath('/')
    updateApplicableConfigsRequest({ name: undefined })
    navigate('/')
  }, [navigate, setBasePath, updateApplicableConfigsRequest])

  return { redirectHome }
}
